module.exports = __webpack_public_path__ + "img/social-instagram.24cfb103.svg";